import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../../lib/helpers';

import Button from '../../../../components/Button/Button';

import { ArrowUpIcon, DeleteIcon } from '../../../../images/shapes';

import { useFieldContext } from '../../../form';

const ListFieldItem = ({
  itemsProps,
  currentValue,
  idx,
  renderListField,
  handleOrderUp,
  handleOrderDown,
  handleDeleteItem,
  disabled,
  isCtdForm = false,
  testId,
  label,
}) => {
  const field = useFieldContext();

  return (
    <div
      className="relative border bg-white dark:border-slate-800 rounded-lg mb-5
       dark:bg-slate-950"
    >
      <div
        className="w-full px-5 py-4 border-b border-slate-200 dark:border-slate-700 text-slate-400
        dark:text-gray-200"
      >
        {label} #{idx + 1}
      </div>
      <div className="bg-white dark:bg-slate-950 pt-2.5 md:pt-5 pb-2 md:pb-4 rounded-b-lg">
        {itemsProps.order.map((itemName) => {
          const fieldName = `${field.name}.${itemName}`;
          return (
            <div key={fieldName} className="px-2.5 md:px-5">
              {renderListField(fieldName, itemName)}
            </div>
          );
        })}
      </div>
      <div className="absolute right-3 top-5 flex flex-row gap-2 md:gap-3">
        {!isCtdForm && currentValue.length > 1 && (
          <>
            <Button
              onClick={() => handleOrderUp(idx)}
              iconImage={
                <ArrowUpIcon
                  className={twMerge(
                    'h-3 md:h-4 text-slate-400',
                    !(disabled || idx === 0) && 'hover:text-gray-700',
                  )}
                />
              }
              buttonColor="borderless"
              noPaddings
              additionalClasses="h-fit w-fit"
              disabled={disabled || idx === 0}
              {...getTestProps(testId, 'up', 'testId')}
            />
            <Button
              onClick={() => handleOrderDown(idx)}
              iconImage={
                <ArrowUpIcon
                  className={twMerge(
                    'h-3 md:h-4 rotate-180 text-slate-400',
                    !(disabled || idx === currentValue.length - 1) &&
                      'hover:text-gray-700',
                  )}
                />
              }
              buttonColor="borderless"
              noPaddings
              additionalClasses="h-fit w-fit"
              disabled={disabled || idx === currentValue.length - 1}
              {...getTestProps(testId, 'down', 'testId')}
            />
          </>
        )}
        <Button
          onClick={() => handleDeleteItem(idx)}
          iconImage={
            <DeleteIcon
              className={twMerge(
                'h-3 md:h-4 text-slate-400',
                !disabled && 'hover:text-gray-700',
              )}
            />
          }
          buttonColor="borderless"
          noPaddings
          additionalClasses="h-fit w-fit"
          disabled={disabled}
          {...getTestProps(testId, 'delete', 'testId')}
        />
      </div>
    </div>
  );
};

export default ListFieldItem;
